<template>
    <div class="bg-lightest col-sm-12 py-4 mt-4">
        <div class="options d-flex align-items-center my-3">
            <!-- <search table="reservations"></search>

            <export :reservations="getReservations"></export> -->

            <div class="col-sm-12">
                <div class="row">

                    <div class="col-sm-12">
                        <div class="row">

                            <div class="d-flex col-md-4 pl-0">
                                <div class="d-flex w-100">
                                    <input class="bg-lighter flexGrow1" type="text" v-model="filters.searchString" placeholder="Search customer, ticket, voucher">
                                    <button class="btn wider blue ml-3" @click='getReservationsPaginated(true)'>Search</button>
                                    <!-- <button class="btn wider tertiary ml-3" @click='clearFilters'>Clear</button> -->
                                    <!-- <div class="glued-left dark" @click='getReservationsPaginated'><i class="ico-search larger color-1"></i></div> -->
                                </div>
                            </div>

                            <div class="col-sm-4">

                                <button class="btn wider bg-dark ml-3" v-if="selectedReservationIds.length > 0" @click="openOptions">Invoice</button>
                            </div>

                            <div class="col-sm-4 d-flex justify-content-end align-items-center">
                                <div class="mr-4">
                                    <checkbox class="" v-model="filters.currentCheckboxNote" @input="resetPagination">
                                        Notes
                                    </checkbox>
                                </div>

                                <export :exportOptions="exportOptions"></export>
                            </div>

                        </div>
                    </div>


                    <div class="col-sm-12 mt-3">
                        <div class="row">

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="getSlimFilters">
                                <!-- <v-select :searchable="true" :options="treatedProductList" label="name" placeholder="All" v-model="filterProduct" @input="changeProductFilter"></v-select> -->
                                <multiselect
                                    ref="productFilter"
                                    v-model="filters.productId"
                                    :options="treatedProductList"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder=""
                                    label="name"
                                    track-by="id"
                                    :searchable="true"
                                    selectLabel=""
                                    deselectLabel=""
                                    selectedLabel=""
                                    class="w-100"
                                >

                                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                                        <span class="multiselect__single" v-if="values.length > 1">{{ values.length }} products selected</span>
                                        <span class="multiselect__single" v-else-if="values.length == 1 ">{{values[0].name}} </span>
                                    </template>

                                    <template slot="option" slot-scope="props">
                                        <i v-if="filters.productId.filter(i => {return i.id == props.option.id}).length" class="far fa-check-square"></i>
                                        <i v-else class="far fa-square"></i>
                                        <span>{{props.option.name}}</span>
                                    </template>

                                    <template slot="placeholder">
                                        All Products
                                    </template>

                                </multiselect>
                            </div>

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="treatedPaymentsStatusList && treatedPaymentsStatusList.length > 0">
                                <!-- <v-select :searchable="true" :options="treatedPaymentsStatusList" label="label" placeholder="All" v-model="filterPayment" @input="changePaymentStatusFilter"></v-select> -->
                                <multiselect
                                    ref="paymentStatusFilter"
                                    v-model="filters.paymentStatus"
                                    :options="treatedPaymentsStatusList"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder=""
                                    label="label"
                                    track-by="id"
                                    :searchable="true"
                                    selectLabel=""
                                    deselectLabel=""
                                    selectedLabel=""
                                    class="w-100"
                                >

                                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                                        <span class="multiselect__single" v-if="values.length > 1">{{ values.length }} payment status selected</span>
                                        <span class="multiselect__single" v-else-if="values.length == 1 ">{{values[0].label}} </span>
                                    </template>

                                    <template slot="option" slot-scope="props">
                                        <i v-if="filters.paymentStatus.filter(i => {return i.id == props.option.id}).length" class="far fa-check-square"></i>
                                        <i v-else class="far fa-square"></i>
                                        <span>{{props.option.label}}</span>
                                    </template>

                                    <template slot="placeholder">
                                        Any Payment Status
                                    </template>

                                </multiselect>
                            </div>

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="eventStatusList && eventStatusList.length > 0">
                                <!-- <v-select :searchable="false" :options="eventStatusList" label="description" placeholder="All" v-model="filterStatus" @input="changeStatusFilter"></v-select> -->
                                <multiselect
                                    ref="statusFilter"
                                    v-model="filters.status"
                                    :options="eventStatusList"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder=""
                                    label="description"
                                    track-by="id"
                                    :searchable="true"
                                    selectLabel=""
                                    deselectLabel=""
                                    selectedLabel=""
                                    class="w-100"
                                >

                                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                                        <span class="multiselect__single" v-if="values.length > 1">{{ values.length }} status selected</span>
                                        <span class="multiselect__single" v-else-if="values.length == 1 ">{{values[0].description}} </span>
                                    </template>

                                    <template slot="option" slot-scope="props">
                                        <i v-if="filters.status.filter(i => {return i.id == props.option.id}).length" class="far fa-check-square"></i>
                                        <i v-else class="far fa-square"></i>
                                        <span>{{props.option.description}}</span>
                                    </template>

                                    <template slot="placeholder">
                                        Any Status
                                    </template>

                                </multiselect>
                            </div>

                            <!-- <div class="col-md-2 d-flex flex-row align-items-center" v-if="transportList && transportList.length > 0">
                                <v-select :searchable="false" :options="transportList" label="name" placeholder="All" v-model="filterTransport" @input="changeTransportFilter"></v-select>
                            </div> -->

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="editedAgentList && editedAgentList.length > 0">
                                <!-- <v-select v-model="selectedSeller" :options="editedAgentList" placeholder="All Agent/Sellers" :searchable="true" label="brandName" @input="updateSeller"></v-select> -->
                                <seller-picker class="w-100" ref="sellerSelector" :allowEmpty="true" :inlcudeWidget="true" placeholder="All Sellers" @input="sellerChanged" @deselect="deselectSeller"></seller-picker>
                            </div>

                            <div class="col-md-2 d-flex flex-row align-items-center pl-0" v-if="editedAgentList && editedAgentList.length > 0">
                                <v-select v-model="selectedCountry" :options="editedCountryList" label="name" placeholder="- Select country -" @input="updateCountry"></v-select>
                            </div>

                            <!-- <div class="col-md-2 d-flex flex-row align-items-center" v-if="notesAndPickupsOptions && notesAndPickupsOptions.length > 0">
                                <v-select v-model="selectedNotesAndPickups" :options="notesAndPickupsOptions" placeholder="All Notes and Pickups" :searchable="true" label="name"></v-select>
                            </div> -->
                            <div class="col-md-2 d-flex flex-row align-items-center pl-0">
                                <button class="btn tertiary" @click='clearFilters'>Clear</button>
                                <!-- <div class="ml-2">
                                    <checkbox class="" v-model="filters.currentCheckboxNote">
                                        Notes
                                    </checkbox>
                                </div> -->
                            </div>

                            <!-- <div class="col-md-2 d-flex flex-row align-items-center justify-content-end">
                            </div> -->


                        </div>
                    </div>

                </div>
            </div>



        </div>



        <div class="col-sm-12 d-flex justify-content-end my-4" v-if="pageInfo && reservationsArr.length > 0">
            <uib-pagination v-if="pageInfo.pageCount > 1" v-model="paginationComputed" :total-items="pageInfo.totalItemCount" :items-per-page="20" :boundary-link-numbers="false" :max-size="7" @change="pageChanged"></uib-pagination>
        </div>

        <list v-if="!isLoadingReservations && reservationsArr" :header="header" :body="body" :rows="reservationsArr" :showNoDataMessage="false"></list>

        <div class="col-sm-12 d-flex justify-content-end my-4" v-if="pageInfo && reservationsArr.length > 0">
            <uib-pagination v-if="pageInfo.pageCount > 1" v-model="paginationComputed" :total-items="pageInfo.totalItemCount" :items-per-page="20" :boundary-link-numbers="false" :max-size="7" @change="pageChanged"></uib-pagination>
        </div>

        <div v-if="!isLoadingReservations && reservationsArr.length == 0" class="text-center p-4">
            <span class="dark font-weight-600 fs-large">No reservations found</span>
        </div>

        <div v-if="isLoadingReservations" class="p-4 my-4 text-center">
            <loader></loader>
        </div>

    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Search from './Search'
    import List from '@/tools/list/baseList'
    import Loader from '@/tools/loaders/loader1'
    import VueDatepicker from 'vuejs-datepicker'
    import extendedVSelect from '@/extends/vue-select'
    import {eventHub} from '../../main'
    import Export from '@/tools/ExportV2'
    import SellerPicker from '@/tools/SellerPicker'
    import Multiselect from 'vue-multiselect'

    import mixpanelMixin from '@/mixins/mixpanel'

    // columns
    import iconsColumn from './reservationLists/columns/icons'

    export default {
        mixins: [
            mixpanelMixin
        ],
        data: function() {
            return {
                reservationsArr: [],
                isLoadingReservations: false,
                // pagination:{
                //     currentPage: 1,
                // },
                pageInfo: null,
                filters:{
                    searchString: null, // string
                    productId: [], // int
                    paymentStatus: [], //int
                    agentId: null, // int
                    userId: null, // int
                    status: [], // int
                    supplierId: null, // int
                    countryId: null, // int
                    eventId: null, // int
                    currentCheckboxPickup: false,
                    currentCheckboxNote: false,
                    channelType: null // int 100 = widget
                },
                exportOptions: [
                    {
                        label: 'Excel',
                        action: this.getExcel
                    }
                ],
                categoryList: [],
                // transportList:[
                //     {
                //         name:'With and without transport',
                //         value:null,
                //     },
                //     {
                //         name: 'Without transport',
                //         value: false
                //     },
                //     {
                //         name: 'With transport',
                //         value: true
                //     },
                // ],
                filterStatus: {
                    id:null,
                    description:'Any Status'
                },
                filterProduct: {
                    id:null,
                    name:'All Products'
                },
                filterPayment: {
                    id:null,
                    label:'Any Payment Status'
                },
                filterTransport: {
                    value:null,
                    name:'With and without transport'
                },
                selectedSeller: {
                    id: null,
                    brandName: 'All Agent/Seller'
                },
                selectedCountry: {
                    id: null,
                    name: "Country"
                },
                notesAndPickupsOptions: [
                    {
                        name: 'Notes and Pickups',
                        id: 0,
                    },
                    {
                        name: 'Notes included',
                        id: 1,
                    },
                    {
                        name: 'Pickups included',
                        id: 2,
                    },
                    {
                        name: 'All',
                        id: 3,
                    },
                ],
                selectedNotesAndPickups: {
                    name: 'Notes and Pickups',
                    id: 0
                },
                selectedReservationIds: []
            }
        },
        created: function() {
            //gets reservations of a given event (id)
            if(this.$route.params.eventId){
                this.filters.eventId = this.$route.params.eventId
            }

            if(this.getSelectedEventListReservations){
                this.filters.eventId = this.getSelectedEventListReservations.id
                // this.setSelectedEventListReservations(null)
            }


            console.log('running created - Reservation Dates');
            this.getReservationsPaginated(false)

            eventHub.$off('updateReservationsList');
            eventHub.$on('updateReservationsList',(data) => {
                if(this.reservationMainFilters.selectedView.id != 2){
                    return false
                }

                console.log('updateReservationsList A', this.reservationMainFilters, data);
                //if data is an object or array
                if(data.id){
                    console.log('setting loader by object');

                    //set row as loading
                    this.reservationsArr.map(reservationEntryOnList => {
                        if(reservationEntryOnList.id == data.id){
                            this.$set(reservationEntryOnList, 'loading', true)
                        }
                    })

                } else {
                    //if its no and object it should be an array
                    console.log('setting loader by array');

                    for (let reservationEntryOnList of this.reservationsArr) {

                        for(let bulkId of data){
                            if(reservationEntryOnList.id == bulkId){
                                this.$set(reservationEntryOnList, 'loading', true)

                            }
                        }

                    }

                }


                this.getReservationsPaginated(false)
            });

            //check if we have supplier info (need supplierId to get the agent list),
            // then gets the agents
            // if(!this.account.account){
            //     this.refreshAccountData().then(response => {
            //         this.initAgents()
            //     })
            // } else {
                // this.initAgents()
            // }


        },
        props: {
            reservationMainFilters: {
                type: Object,
                default: null
            },
            pagination: {
                type: Object
            }
        },
        watch: {
            'reservationMainFilters':{
                handler: function (val, oldVal) {
                    //if props change (the range date for example)
                    this.getReservationsPaginated(true)
                },
                deep: true
            },
            'filters':{
                handler: function (val, oldVal) {
                    console.log('FILTERS CHANGED');
                    this.getReservationsPaginated(true)
                },
                deep: true
            },
            'getSelectedEventListReservations':{
                handler: function (newVal, oldVal) {
                    if(this.getSelectedEventListReservations){
                        this.filters.eventId = this.getSelectedEventListReservations.id
                    } else {
                        this.filters.eventId = null
                    }
                    this.getReservationsPaginated(false)
                }
            }
        },
        computed: {
            ...mapGetters([
                // 'getReservations',
                'getReservationsLabels',
                'account',
                'getEventReservations',
                'getAgents',
                'getCountries',
                'getSlimFilters',
                'getReservionStates',
                'getSelectedEventListReservations',
                'getPaymentsStatusList'
            ]),
            treatedProductList: function() {
                let output = JSON.parse(JSON.stringify(this.getSlimFilters.productList));

                // output.unshift({
                //     id:null,
                //     name:'All Products'
                // })
                return output
            },
            treatedPaymentsStatusList: function() {
                let output = JSON.parse(JSON.stringify(this.getPaymentsStatusList));

                // output.unshift({
                //     id:null,
                //     label:'Any Status'
                // })
                return output
            },
            requestFilterOptions: function() {
                return {
                    's.String': this.filters.searchString,
                    's.ProductId': this.filters.productId && this.filters.productId.length > 0? this.filters.productId.map(item => item.id) : null,
                    's.agentId': this.filters.agentId,
                    's.userAccountId': this.filters.userId,
                    's.PaymentStatus': this.filters.paymentStatus && this.filters.paymentStatus.length > 0? this.filters.paymentStatus.map(item => item.id) : null,
                    's.StatusList': this.filters.status && this.filters.status.length > 0 ? this.filters.status.map(item => item.id) : null,
                    supplierId: this.account.supplierId,
                    's.withTransport': true,
                    's.withNote': this.filters.currentCheckboxNote? true : null,
                    's.eventId': this.filters.eventId,
                    's.countryId': this.filters.countryId,
                    's.transferDateStart': this.reservationMainFilters.dateRange[0],
                    's.transferDateEnd': this.reservationMainFilters.dateRange[1],
                    's.channelType': this.filters.channelType,
                    page: this.pagination.currentPage,
                    pageSize: 20
                }
            },
            header: function() {
                return {
                    selection: {
                        active: false,
                        event: function(event) {
                            console.log('selecte all', event);
                            vm.selectAllReservations(event)
                        }
                    },
                    list: {
                        pickupDate: 'Pickup Date',
                        pickupLocation: 'Pickup',
                        seller: 'Seller',
                        hotel: 'Hotel/Rom',
                        reservation: 'Reservation',
                        fullName: 'Customer',
                        created: 'Created',
                        icons: '',
                    },
                };
            },
            body: function() {
                let vm = this;

                return {
                    selection: {
                        active: false,
                        event: function(event, reservation) {
                            if(vm.selectedReservationIds.indexOf(reservation.id) >= 0){
                                // console.log('a - '+reservation.id);
                                vm.selectedReservationIds.splice(vm.selectedReservationIds.indexOf(reservation.id), 1);
                            } else {
                                // console.log('b - '+reservation.id);
                                vm.selectedReservationIds.push(reservation.id)
                            }

                            vm.setBulkSelectedIds(vm.selectedReservationIds)
                        }
                    },
                    customRowEvent: function(reservation) { vm.view(reservation.id)},
                    customCells: {
                        pickupDate: function(reservation) {
                            if(reservation.transport.transfers.length > 0){
                                return vm.formatDateDots(reservation.transport.transfers[0].date)+'<br>'+vm.formatTime(reservation.transport.transfers[0].date)
                            } else {
                                return '-'
                            }
                        },
                        pickupLocation: function(reservation) {
                            if(reservation.transport.transfers.length > 0){
                                return reservation.transport.transfers[0].stop.name
                            } else {
                                return '-'
                            }
                        },
                        seller: function(reservation) {
                            if(reservation.channelType >= 100 && reservation.channelType <= 102){
                                return 'Widget'
                            } else if(reservation.channelType == 201){
                                return 'Pluralo Locals'
                            } else if(reservation.channelType == 202){
                                return 'Get Your Guide'
                            } else {
                                return reservation.creatorAgent? reservation.creatorAgent.brandName + ' (Agent)' : reservation.creatorUserAccount? reservation.creatorUserAccount.name : ''
                            }
                        },
                        hotel: function(reservation) {
                            if(reservation.customer.room != ""){
                                return reservation.customer.accomodation + ' / ' + reservation.customer.room
                            } else {
                                return reservation.customer.accomodation
                            }

                        },
                        reservation: function(reservation) {
                            if(reservation.event.product){
                                const p = reservation.event.product;
                                return vm.multiLevelHtml(vm.formatTicketNumber(reservation.id), p.name);
                            } else {
                                return 'missing'
                            }

                        },
                        fullName: function(reservation) {
                            const c = reservation.customer;
                            return (c.name !== undefined && c.surname !== undefined) ? c.name + ' ' + c.surname : '-';
                        },
                        created: function(reservation) {
                            return vm.formatDateDots(reservation.reservationDate)+'<br>'+vm.formatTime(reservation.reservationDate)
                        },
                        icons: function(reservation) {
                            return {
                                component: iconsColumn,
                                arguments: reservation
                            }
                        },
                    },
                    customClassCell: {
                        reservation : 'pointer',
                        created : 'pointer',
                        pax : 'pointer',
                        totalPrice : 'pointer',
                        fullName : 'pointer',
                        seller : 'pointer',
                        status : 'pointer',
                        checkin : 'pointer',
                        noshow : 'pointer',
                    },
                    // rowEvent: this.view(event)
                }
            },
            productsList: function(){
                let outputArr = [];

                this.getReservations.forEach(function(reservation){
                    if(reservation.event.product && outputArr.indexOf(reservation.event.product.name) == -1){
                        outputArr.push(reservation.event.product.name)
                    }
                });

                return outputArr;
            },
            agentMe: function() {
                return {brandName: this.account.name + ' (Me)', name: null}
            },
            editedAgentList: function() {
                let agentList = JSON.parse(JSON.stringify(this.getAgents));


                let agentMustHaveName = agentList.filter(agent => {
                    return agent.name != null
                })

                agentMustHaveName.unshift(this.agentMe)
                agentMustHaveName.unshift({
                    id: null,
                    brandName: 'All Agent/Seller'
                })

                return agentMustHaveName;
            },
            editedCountryList: function() {
                let output = this.getCountries
                if(output[0].id != null){
                    output.unshift({
                        id: null,
                        name: "All Countries"
                    })
                }
                return output
            },
            eventStatusList: function() {
                let output = JSON.parse(JSON.stringify(this.getReservionStates));

                // output.unshift({
                //     description: "Any Status",
                //     id: null
                // })

                return output
            },
            paginationComputed: {
                get: function () {
                    return this.pagination
                },
                set: function(newValue) {
                    this.$emit('paginationChanged', newValue)
                    // this.getReservationsPaginated()
                    // console.log(pagination);
                }
            }
        },
        methods: {
            ...mapActions([
                'addReservation',
                'refreshAccountData',
                'setSelectedReservation',
                'setEventReservations',
                'openModal',
                'pushReservationToStore',
                // 'initAgents',
                'refreshAccountData',
                'setBulkSelectedIds',
                'setReservationListFilters',
                'setReservationListAllSelected'
            ]),
            clearFilters: function() {
                this.filters = {
                    productId: [], // int
                    paymentStatus: [], //int
                    agentId: null, // int
                    status: [], // int
                    supplierId: null, // int
                    eventId: null, // int
                    countryId: null, // int
                    currentCheckboxPickup: false,
                    currentCheckboxNote: false,
                    userId: null, // int
                }


                this.filterStatus = null

                this.filterPayment = null

                this.filterStatus = null

                this.selectedSeller = null

                this.filterProduct = null

                this.selectedCountry = null

                if(this.$refs.sellerSelector){
                    this.$refs.sellerSelector.deselectSeller()
                }


                // this.filterTransport = {
                //     id:null,
                //     name:'With and without transport'
                // },

                // clear multiSelects search
                this.$refs.productFilter.search = ""
                this.$refs.paymentStatusFilter.search = ""
                this.$refs.statusFilter.search = ""

                this.getReservationsPaginated(false)

                this.resetPagination()
            },
            formatMoney: function(value) {
                return parseFloat(value).toFixed(2) + '€';
            },
            pageChanged: function(){
                console.log('page changed');
                this.getReservationsPaginated(false)
            },
            getReservationsPaginated: _.debounce(
                // _.debounce is a function provided by lodash to limit how
                // often a particularly expensive operation can be run.
                // In this case, we want to limit how often we access
                // yesno.wtf/api, waiting until the user has completely
                // finished typing before making the ajax request. To learn
                // more about the _.debounce function (and its cousin
                // _.throttle), visit: https://lodash.com/docs#debounce
                function(userFiltered) {
                    let vm = this
                    this.selectAllReservations(false)
                    if(!this.isLoadingReservations){
                        this.isLoadingReservations = true
                        axios.get('/api/booking/TransfersList',{
                            params: this.requestFilterOptions
                        }).then(response => {
                            this.isLoadingReservations = false
                            if(response.status == 200){
                                this.pageInfo = response.data.pageInfo;
                                this.reservationsArr = response.data.result;
                                // mixpanel
                                if(userFiltered){
                                    // vm.$ma.trackEvent({action:'Filtered Reservations By Departure Date', properties: vm.requestFilterOptions})
                                    vm.trackFilter('Filtered Reservations','Pickup Date', vm.requestFilterOptions)
                                    // console.log('sending this to mixpanel', {action:'Filtered Reservations By Departure Date', properties: vm.requestFilterOptions});
                                }
                            }
                        }).catch(e => {
                            this.isLoadingReservations = false
                        })
                    }
                },
                500
            ),
            multiLevelHtml: function(top, bottom) {
                return '<div><b>' + top + '</b></div><div class="sub">' + bottom + '</div>';
            },
            view: function(ticketNr) {
                let vm = this;
                axios.get('api/reservation/FindReservationBySupplier', {
                    params: {
                        supplierId: vm.account.supplierId,
                        reservationId: ticketNr
                    }
                }).then((response) => {
                    if(response !== null && response !== undefined && response.status == 200){
                        if(response.data !== null){
                            //ticket exists
                            // vm.updateClonedReservation(response.data);
                            // vm.triggerModal(Number(vm.ticketNr), 'ReservationView');
                            // this.$router.push('/reservations')
                            this.pushReservationToStore(response.data)
                            this.triggerModal(response.data, 'ReservationEdit');
                        }
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            triggerModal: function(reservation, modal) {
                this.setSelectedReservation(reservation);
                this.openModal(modal);
            },
            changeStatusFilter: function() {
                this.resetPagination()
                if(this.filterStatus){
                    this.filters.status = this.filterStatus.id
                } else {
                    this.filters.status = null
                    this.filterStatus = {
                        id:null,
                        description:'Any Status'
                    }
                }
            },
            changePaymentStatusFilter: function() {
                this.resetPagination()
                if(this.filterPayment){
                    this.filters.paymentStatus = this.filterPayment.id
                } else {
                    this.filters.paymentStatus = null
                    this.filterPayment = {
                        id:null,
                        label:'Any Payment Status'
                    }
                }
            },
            changeTransportFilter: function() {
                if(this.filterTransport){
                    this.filters.withTransport = this.filterTransport.value
                } else {
                    this.filters.withTransport = null
                    this.filterTransport = {
                        id:null,
                        name:'With and without transport'
                    }
                }
            },
            resetPagination: function () {
                this.$emit('resetPagination')
            },
            changeProductFilter: function() {
                this.resetPagination()
                if(this.filterProduct){
                    this.filters.productId = this.filterProduct.id
                } else {
                    this.filters.productId = null
                    this.filterProduct = {
                        id:null,
                        name:'All Products'
                    }
                }
            },
            updateSeller: function() {
                if(this.selectedSeller){
                    this.filters.agentId = this.selectedSeller.id
                } else {
                    this.filters.agentId = null
                    this.selectedSeller = {
                        id: null,
                        brandName: 'All Agent/Seller'
                    }
                }
            },
            updateCountry: function() {
                this.resetPagination()
                if(this.selectedCountry){
                    this.filters.countryId = this.selectedCountry.id
                } else {
                    this.filters.countryId = null
                    this.selectedCountry = {
                        id: null,
                        name: 'Country'
                    }
                }
            },
            getExcel: function() {
                axios.get('/api/booking/TransfersDownload', {
                    params: this.requestFilterOptions,
                    responseType: 'blob'
                }).then(response => {
                    if (response.status == 200) {

                        window.URL = window.URL || window.webkitURL;
                        const headers = response.headers;
                        const blob = new Blob([response.data],{type:headers['content-type']});
                        const link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = window.URL.createObjectURL(blob);
                        let namePrefix = ''
                        if(this.reservationMainFilters.dateRange[0] && this.reservationMainFilters.dateRange[1]){
                            namePrefix = moment(this.reservationMainFilters.dateRange[0]).format('YYYY-MM-DD') + '_' + moment(this.reservationMainFilters.dateRange[1]).format('YYYY-MM-DD') + '_'
                        }
                        link.download = namePrefix + 'pickups.xlsx';
                        link.click();

                    }
                })
            },
            selectSelectedReservations: function(reservations) {
                for (let reservation of reservations) {
                    for (let selectedReservationId of this.selectedReservationIds) {
                        if(reservation.id == selectedReservationId){
                            this.$set(reservation, 'selected', true)
                        }
                    }

                }

                return reservations
            },
            selectAllReservations: function(state) {
                this.setReservationListAllSelected(state)
                for (let reservation of this.reservationsArr) {
                    this.$set(reservation, 'selected', state)

                    //if adding to selection
                    if(state){
                        if(this.selectedReservationIds.indexOf(reservation.id) == -1){
                            this.selectedReservationIds.push(reservation.id)
                        }
                    } else {
                        //if removing from selection
                        if(this.selectedReservationIds.indexOf(reservation.id) != -1){
                            this.selectedReservationIds.splice(this.selectedReservationIds.indexOf(reservation.id), 1)
                        }
                    }
                }
            },
            openOptions: function() {
                this.setReservationListFilters(this.requestFilterOptions)
                this.openModal('ReservationsBulkActions');
            },
            sellerChanged: function(e) {
                this.resetPagination()
                if(e.userAccountTypes){
                    console.log('My team member');
                    this.$set(this.filters, 'userId', e.id)
                    this.$set(this.filters, 'agentId', null)
                    this.$set(this.filters, 'channelType', null)
                } else if(e.channelType) {
                    console.log('is Channel');
                    this.$set(this.filters, 'channelType', e.channelType)
                    this.$set(this.filters, 'userId', null)
                    this.$set(this.filters, 'agentId', null)
                    return true
                } else if(e.isAllSellers) {
                    console.log('is all sellers');
                    this.$set(this.filters, 'userId', null)
                    this.$set(this.filters, 'agentId', null)
                    this.$set(this.filters, 'channelType', null)
                    this.selectedSeller = {
                        id: null,
                        brandName: 'All Sellers'
                    }
                    return true
                } else {
                    console.log('is Agent');
                    this.$set(this.filters, 'userId', null)
                    this.$set(this.filters, 'agentId', e.id)
                    this.$set(this.filters, 'channelType', null)
                }

                this.getReservationsPaginated(false)

            },
            deselectSeller: function() {
                this.filters.userId = null
                this.filters.agentId = null
            }
        },
        components: {
            List,
            Loader,
            Search,
            Export,
            vSelect: extendedVSelect,
            VueDatepicker,
            Export,
            SellerPicker,
            Multiselect
        }
    }
</script>

<style lang="scss">
@import '../../assets/scss/_variables.scss';
@import '../../assets/scss/_utility.scss';

//loader
.loaderHolder{
    background: #C5D0DE;
    padding: 7px;
    width: 52px;
    @extend .radius-normal;
}

.loader,
.loader:before,
.loader:after {
    border-radius: 50%;
    width: 1em;
    height: 1em;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    -webkit-animation: load7 1.8s infinite ease-in-out;
    animation: load7 1.8s infinite ease-in-out;
}
.loader {
    color: #8CA0B3;
    font-size: 10px;
    // margin: 1px auto;
    position: relative;
    text-indent: -9999em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
}
.loader:before,
.loader:after {
    content: '';
    position: absolute;
    top: 0;
}
.loader:before {
    left: -1.3em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
}
.loader:after {
    left: 1.3em;
}
@-webkit-keyframes load7 {
    0%,
    80%,
    100% {
        box-shadow: 15px 0 0 -1.3em;
    }
    40% {
        box-shadow: 15px 0 0 0;
    }
}
@keyframes load7 {
    0%,
    80%,
    100% {
        box-shadow: 15px 0 0 -1.3em;
    }
    40% {
        box-shadow: 15px 0 0 0;
    }
}
</style>



// WEBPACK FOOTER //
// ReservationsByPickupDate.vue?16df6498